
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationReturnGrid extends _Ext.GridBase<CertificationReturnRow, any> {
        protected getColumnsKey() { return 'Inventory.CertificationReturn'; }
        protected getDialogType() { return CertificationReturnDialog; }
        protected getIdProperty() { return CertificationReturnRow.idProperty; }
        protected getInsertPermission() { return CertificationReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return CertificationReturnRow.localTextPrefix; }
        protected getService() { return CertificationReturnService.baseUrl; }
        //private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            var item = this.itemAt(row);
            super.onClick(e, row, cell);
        }

        protected addButtonClick() {

            let now = new Date();
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[82].AutoPosting;
            var voucherNo = FormatHelper.GetVoucherNo(82);

            this.editItem(<CertificationIssueRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 82,
                TransDate: now.toDateString(),
                AutoPosting: autoposting

            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}